// Check navigation items to see if they match the current URL, and highlight the matching one if so.
// If there is no direct match, use the breadcrumbs to try to find a match.
jQuery(function () {
  var selectors = {
    navigationItem: '[data-behaviour="navigation-item"]',
    breadcrumb: '[data-behaviour="breadcrumb"]',
  };
  var selectedClass = "current";

  var locationUrls = [
    window.location.pathname + window.location.search, // In case the navigation item contains query params
    window.location.pathname,
  ];

  var breadcrumbUrls = [];
  jQuery(selectors.breadcrumb).each(function () {
    return breadcrumbUrls.push(getUrl(this));
  });

  // Reverse breadcrumb order so we start with the most specific
  var urls = locationUrls.concat(breadcrumbUrls.reverse());

  jQuery.each(urls, checkForNavItemMatch);

  // HELPERS

  function checkForNavItemMatch(i, url) {
    return jQuery(selectors.navigationItem).each(function () {
      if (getUrl(this) === url) {
        selectNavItem(this);

        return false; // Only one group at most should be selected
      }
    });
  }

  function selectNavItem(navItem) {
    jQuery(navItem).addClass(selectedClass).parents(selectors.navigationItem).addClass(selectedClass);
  }

  function getUrl(el) {
    return jQuery(el).data("url") || jQuery(el).attr("href");
  }
});
